export const DUMMY_SECTION_TEAMS = [
  {
    isDummy: true,
    coverProps: {
      height: '22.7rem',
      width: '100%',
      position: {}
    }
  },
  {
    isDummy: true,
    coverProps: {
      height: '23rem',
      width: '100%',
      position: { bottom: 0 }
    }
  }
];
